<template>
  <div class="bb-notifications-bar-main-lis-of-project">
    <div class="bb-notifications-bar-main-lis-of-project__description">
      {{value}}
    </div>
    <div class="bb-notifications-bar-main-lis-of-project__description">
      Please review the project and move it to Active in the List of projects.
    </div>
    <div class="bb-notifications-bar-main-lis-of-project__description">
      Project management section administrator
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'NotificationsBarMainListOfProject',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    value () {
      const { comment } = this.item
      const value = comment.split('Æ')
      if (!value.length) return
      const [first, last] = value
      return `${first} ${this.date(last)}`
    }
  },
  methods: {
    date (fullDate) {
      const date = moment(fullDate).format('MMM D, YYYY')
      const time = moment(fullDate).format('h:mm a')
      return `${date} at ${time}`
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../sass/variables";

  .bb-notifications-bar-main-lis-of-project {
    display: grid;
    grid-gap: 7px 0;

    &__description {
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarMainListOfProject.vue